module.exports = __webpack_public_path__ + "assets/caa4b7dc6b966468919832a2ddd320dd.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/buttons/auto.mp3
 ** module id = 22
 ** module chunks = 0
 **/